import { SCHEDULER_QUERY_KEYS } from 'api/Schedular/keys';
import { FILTER_QUERY_KEYS } from 'pages/DashboardV2/api/keys';
import { queryClient } from 'lib/queryClient';

export const handleProjectCreateSuccess = () => {
  queryClient.invalidateQueries({
    queryKey: [SCHEDULER_QUERY_KEYS.LIST_PROJECTS],
  });
};

export const handleProjectUpdateSuccess = (projectId: string) => {
  queryClient.invalidateQueries({
    queryKey: [FILTER_QUERY_KEYS.PROJECT_BY_ID, projectId],
  });
};
